import routes from '@modules/stripe/stripe-charge/stripe-charge-routes';
import store from '@modules/stripe/stripe-charge/stripe-charge-store';

export default {
        routes,
        store,
};